import axios from "axios";
import Navbar from "./Navbar";
import { use, useEffect, useRef, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { Grade } from "@mui/icons-material";
// import { Map } from "react-map-gl";
import 'mapbox-gl/dist/mapbox-gl.css';
// import { mapboxgl } from "mapbox-gl";
import * as mapboxgl from "mapbox-gl";
import { useLocation } from "react-router-dom";
import Marker from "./Marker";
import Popup from "./Popup";

export default function Search() {

    var url = `http://localhost:${process.env.PORT || 3000}/`;
    var loc = useLocation();
    var uri = new URLSearchParams(loc.search);
    var address = uri.get('address');
    var lat = uri.get('lat');
    var lon = uri.get('lon');

    const [shops, setshops] = useState([]);

    const mapRef = useRef();
    const mapContainerRef = useRef();
    const [activeFeature, setActiveFeature] = useState();

    useEffect(() => {
        mapboxgl.accessToken = 'pk.eyJ1IjoibmFrc2hzaGFybWEiLCJhIjoiY21sMTdlNmZmMDR3bTNlc2FubmRveWE1ciJ9.FUCHDeqJcf1GrgdiPTIRiQ'
        mapRef.current = new mapboxgl.Map({
            container: mapContainerRef.current,
            center: [lon, lat],
            zoom: 10,
        });
        return () => {
            mapRef.current.remove()
        }
    }, [])

    const [results, setresults] = useState([]);
    function fetch() {
        if (address && lat && lon) {
            console.log(lat);
            console.log(lon)
            axios.post(url + 'searchForPlaces', {
                name: address,
                lat: lat,
                lon: lon
            }).then((succ) => {
                setresults(succ.data.shops);
                console.log('results', succ.data.shops);
            })
        }
    }
    useEffect(() => {
        fetch();
    }, [address, lat, lon])
    // useEffect(() => {
    //     if (!mapRef.current) return;

    //     results.forEach((row) => {
    //         new mapboxgl.Marker()
    //             .setLngLat([Number(row.Long), Number(row.Lat)])
    //             .setPopup(
    //                 new mapboxgl.Popup().setHTML(`<h4>${row.Name}</h4>`)
    //             )
    //             .addTo(mapRef.current);
    //     });

    // }, [results]);
    // const handleMarkerClick = (feature) => {
        // setActiveFeature(feature)
    // }
    function handleMarkerClick(x) {
        setActiveFeature(x)
    }


    return (
        <>

            <Navbar />

            <Grid container className='w-100' p={3}>
                <Grid height={'85vh'} className='overflow-auto' size={{ lg: 7 }}>

                    <Grid container justifyContent={'space-between'}>
                        {results.map((row) => (
                            <Grid size={{ lg: 5.7 }} className='mt-3 cursor-pointer'>
                                <img src="https://images.fresha.com/locations/location-profile-images/278430/3939729/1c05ac7f-f3c6-40c5-8b9a-c2852883aca6-VinnysSalon-IN-Haryana-Gurugram-DLFPhaseIV-Fresha.jpg?f_width=828" className="img-fluid rounded" />
                                <div className="d-flex justify-content-between mt-2">
                                    <Typography variant="h6" fontSize={20} fontWeight={700}>{row.Name.length > 25 ? (row.Name.substr(0, 23) + '...') : row.Name}</Typography>
                                    <div className="d-flex align-items-center">
                                        <Grade fontSize="medium" sx={{ color: '#FFC00A' }} />
                                        <span className="fw-bold ms-1">4.9</span>
                                        <span className="text-secondary ms-1">(2,615) <br />

                                        </span>
                                    </div>
                                </div>
                                <span className="address-font col-6">
                                    {/* {row.distance < 1000 ? } */}
                                    {(Number(row.distance) / 1000).toFixed(1)} km
                                </span>
                                <span className="d-block address-font">Hair Salon</span>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
                <Grid size={{ lg: 5 }} height={'80vh'} pl={3} borderRadius={5} overflow={'hidden'}>
                    {/* <Grid className='h-100 w-100' > */}
                    <div className="w-100 h-100 map overflow hidden" ref={mapContainerRef} id="map" />
                    {mapRef.current && results.length > 0 && results.map((row, index) => {
                        return (
                            <Marker key={index} map={mapRef.current} isActive={activeFeature?._id == row._id} feature={row} onClick={() => handleMarkerClick(row)} />
                        )
                    })}
                    {mapRef.current && (
                        <Popup
                            map={mapRef.current}
                            activeFeature={activeFeature}
                        />
                    )}
                    {/* </Grid> */}
                </Grid>
            </Grid>

        </>
    )

}